import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpEvent, HttpRequest } from '@angular/common/http';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { BasicInventionDetailsDataForm } from '../_models/basic-invention-details-data-form';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';


@Injectable()
export class BasicOfInventionDetailsService {

  constructor(private http: HttpClient, private authService: AuthService) { }

  public static readonly URL_QUESTIONANSWER_CONTROLLER = environment.apiUrl + '/basicInventionDetails/';

  public static readonly URL_SAVEANDUPDATE_BASICINVENTIONDETAILS = BasicOfInventionDetailsService.URL_QUESTIONANSWER_CONTROLLER + "saveUpdate/";
  public static readonly URL_INVENTIONPROGRESS_LIST = BasicOfInventionDetailsService.URL_QUESTIONANSWER_CONTROLLER + "getAll/";
  public static readonly URL_INVENTIONPROGRESS_BYID = BasicOfInventionDetailsService.URL_QUESTIONANSWER_CONTROLLER + "getByid/";
  public static readonly URL_SAVEANDUPDATEWITHFILE_BASICINVENTIONDETAILS = BasicOfInventionDetailsService.URL_QUESTIONANSWER_CONTROLLER + "saveUpdateWithFile/";
  public static readonly URL_BASIC_INVENTION_DETAILS_BY_USER_ID = BasicOfInventionDetailsService.URL_QUESTIONANSWER_CONTROLLER + "getBasicInventionDetailsByUserid/";

  public static readonly GETPDF = BasicOfInventionDetailsService.URL_QUESTIONANSWER_CONTROLLER + "getPdf/";
  public static readonly URL_BASICINEVENTION_BYPROJECTID = BasicOfInventionDetailsService.URL_QUESTIONANSWER_CONTROLLER + "getByProjectid/";


  saveAndUpdateBasicInventionDetails(basicInventionDetailsDataForm: BasicInventionDetailsDataForm) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(BasicOfInventionDetailsService.URL_SAVEANDUPDATE_BASICINVENTIONDETAILS + '/' + userToken, basicInventionDetailsDataForm)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  uploadStaffDocument(basicInventionDetailsDataForm: BasicInventionDetailsDataForm, file: File) {
    const userToken: string = this.authService.getUserToken();
    const formdata: FormData = new FormData();
    formdata.append('file', file);
    formdata.append('documentUploadForm', JSON.stringify(basicInventionDetailsDataForm));
    const req = new HttpRequest('POST', BasicOfInventionDetailsService.URL_SAVEANDUPDATEWITHFILE_BASICINVENTIONDETAILS + '/' + userToken, formdata, {
      reportProgress: true,
      responseType: 'text'
    });
    // return this.http.request(req)
    //  .pipe(catchError(this.handleError('Request Failed')));

    return this.http.post(BasicOfInventionDetailsService.URL_SAVEANDUPDATEWITHFILE_BASICINVENTIONDETAILS + '/' + userToken, formdata)
      .pipe(catchError(this.handleError('Request Failed')));

  }


  getBasicInventionList() {
    let userToken: string = this.authService.getUserToken();
    return this.http.get(BasicOfInventionDetailsService.URL_INVENTIONPROGRESS_LIST + userToken)
      .pipe(catchError(this.handleError('Request Failed')));
  }


  getBasicInventionDetailsByID(id) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(BasicOfInventionDetailsService.URL_INVENTIONPROGRESS_BYID + id + '/' + userToken, id)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  getBasicInventionDetailsByUserID(id) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(BasicOfInventionDetailsService.URL_BASIC_INVENTION_DETAILS_BY_USER_ID + id + '/' + userToken, id)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  generatePDFDoc(projectId,userId,moduleType) {
    let userToken: string = this.authService.getUserToken();
    return this.http.get(BasicOfInventionDetailsService.GETPDF + projectId + '/' + userId + '/'+ moduleType + '/' + userToken, projectId)
      .pipe(catchError(this.handleError('Request Failed')));
  }


  getBasicInventionDetailsByprojectId(projectId) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(BasicOfInventionDetailsService.URL_BASICINEVENTION_BYPROJECTID + projectId + '/' + userToken, projectId)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse) => {
      console.log(error);
      if (error.status === 401) {
        localStorage.removeItem('currentUser');
        window.location.replace('');
      }
      return Observable.throw(error);
    };
  }

}
